<div class="container version">
    <div *ngIf="app"><span class="fw-bold">v{{appVersion}}</span></div>
    <div *ngIf="tdd">TDD<span class="fw-bold" >{{tddVersion}}</span></div>
</div>